<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('manage.products.tags')">Product Tags</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Edit
    </h1>
    <div class="bg-white shadow sm:rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <Form @submit="updateForm" :label-input="form.label" :preset-input="form.preset" :processing="processing" :publish-input="form.publish === 1" :presets="presets"></Form>
      </div>

    </div>
  </div>

</template>

<script>
import Form from './Form'
import Layout from '@/Shared/Admin/Layout'
const tagPresets = {
  yellowish: "tag-yellowish",
  blueish: "tag-blueish",
  greenish: "tag-greenish",
  red: "tag-red",
  blue: "tag-blue",
  green: "tag-green",
  yellow: "tag-yellow"
};

export default {
  name: 'EditTag',
  components: { Form },
  layout: Layout,
  props: {
    tag: Object
  },
  data() {
    return {
      presets: tagPresets,
      processing: false,
      form: {
        label: this.tag.label || null,
        preset: this.tag.preset || null,
        publish: this.tag.publish || null,
      }
    }
  },
  methods: {
    updateForm(formData) {
      this.form.label = formData.label;
      this.form.preset = formData.preset;
      this.form.publish = formData.publish === true;

      this.processing = true
      this.$inertia.put(this.route('manage.products.tags.update', {tag: this.tag.id}), this.form, {
        onFinish: () => this.processing = false
      })
    }
  }

}
</script>
